<template>
  <div class="p-3">
    <a-table
      class="table datatable thead-light"
      :columns="columns"
      :data-source="rows"
      :loading="loading"
      row-key="id"
      :row-selection="rowSelection"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'employee'">
          <div class="d-flex align-items-center">
            <div class="avatar avatar-md me-2">
              <img :src="avatar(record)" class="rounded-circle" alt="user" />
            </div>
            <div>
              <div class="fw-medium">
                {{ fullName(record) }}
              </div>
              <div class="text-muted small">
                {{ record?.employee?.user?.email }}
              </div>
            </div>
          </div>
        </template>

        <template v-else-if="column.key === 'department'">
          {{
            record?.department?.name ||
            record?.employee?.department?.name ||
            "-"
          }}
        </template>

        <template v-else-if="column.key === 'notice_date'">
          {{ formatDate(record.notice_date) }}
        </template>

        <template v-else-if="column.key === 'termination_date'">
          {{ formatDate(record.termination_date) }}
        </template>

        <template v-else-if="column.key === 'action'">
          <div class="action-icon d-inline-flex">
            <a
              v-if="record.status === 'Approved'"
              href="javascript:void(0);"
              class="me-2"
              title="Pay gratuity"
              @click="$emit('gratuity', record)"
            >
              <i class="ti ti-cash"></i>
            </a>
            <a
              href="javascript:void(0);"
              class="me-2"
              @click="$emit('edit', record)"
              v-can="'Termination.Edit'"
            >
              <i class="ti ti-edit"></i>
            </a>
            <a href="javascript:void(0);" @click="$emit('delete', record)" v-can="'Termination.Delete'">
              <i class="ti ti-trash"></i>
            </a>
          </div>
        </template>
      </template>
    </a-table>
  </div>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
  rows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
});
const emit = defineEmits(["edit", "delete", "bulk-delete", "gratuity"]);

const selectedRowKeys = ref([]);

const columns = [
  { title: "Employee", dataIndex: "employee", key: "employee" },
  { title: "Department", dataIndex: "department", key: "department" },
  {
    title: "Termination Type",
    dataIndex: "termination_type",
    key: "termination_type",
  },
  { title: "Notice Date", dataIndex: "notice_date", key: "notice_date" },
  { title: "Reason", dataIndex: "reason", key: "reason" },
  {
    title: "Termination Date",
    dataIndex: "termination_date",
    key: "termination_date",
  },
  { title: "Status", dataIndex: "status", key: "status" },
  { title: "", dataIndex: "action", key: "action" },
];

const rowSelection = {
  selectedRowKeys: selectedRowKeys.value,
  onChange: (keys) => {
    selectedRowKeys.value = keys;
  },
  onSelect: () => {},
  onSelectAll: () => {},
};

function fullName(r) {
  const u = r?.employee?.user;
  if (!u) return "-";
  return [u.first_name, u.last_name].filter(Boolean).join(" ");
}
function avatar(r) {
  // plug your employee avatar URL if available in r.employee.avatar
  const u = r?.employee;
  if (u?.avatar_url) return u.avatar_url;

  return require("@/assets/img/users/user-01.jpg");
}
function formatDate(v) {
  if (!v) return "-";
  try {
    return new Date(v).toLocaleDateString();
  } catch {
    return v;
  }
}

// Expose a bulk delete trigger (e.g., top-right button if needed)
// For simplicity, trigger via console or add a small toolbar you prefer.
// Here we emit when selection changes and user presses DEL key, you can add a button:
window.addEventListener("keydown", (e) => {
  if (e.key === "Delete" && selectedRowKeys.value.length) {
    emit("bulk-delete", selectedRowKeys.value);
  }
});
</script>
